/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MaritalStatus {
    MARRIED = 'married',
    COHABITING = 'cohabiting',
    WIDOWED = 'widowed',
    SINGLE = 'single',
    DIVORCED = 'divorced',
    NOT_APPLICABLE_CHILD = 'notApplicableChild',
}
